"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.finaliseUpload = exports.uploadChunk = void 0;
/* eslint-disable prettier/prettier */
var axios_1 = __importDefault(require("axios"));
var api = __importStar(require("./api"));
var websocket = __importStar(require("./websocket"));
var log = __importStar(require("./helpers/logger"));
var calculateAverageUploadSpeed_1 = require("./helpers/calculateAverageUploadSpeed");
var averageUploadSpeed = (0, calculateAverageUploadSpeed_1.calculateAverageUploadSpeed)();
/**
 * Start uploading a chunk
 */
var uploadChunk = function (_a, state) {
    var chunk = _a.chunk, uploader = _a.uploader;
    return __awaiter(void 0, void 0, void 0, function () {
        var CancelToken, source, fileUpload, startTimeChunkUpload;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    CancelToken = axios_1.default.CancelToken;
                    source = CancelToken.source();
                    state.uploadJobs.addRequestSource(chunk.id, source);
                    fileUpload = state.fileUploads.getByFileId(chunk.fileId);
                    if (!(chunk.number === 1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, websocket.promisifySubscribeToFileUploadConfirmation(fileUpload)];
                case 1:
                    _b.sent();
                    uploader.events.onRegistered(chunk.fileId, fileUpload.id);
                    log.info("Uploading: ".concat(fileUpload.id));
                    _b.label = 2;
                case 2:
                    startTimeChunkUpload = new Date().getTime();
                    // Do actual POST request
                    api
                        .upload(chunk, source.token, uploader, fileUpload)
                        .then(function () {
                        var _a, _b;
                        state.fileUploads.incrementChunksDoneCount(chunk.fileId);
                        uploader.chunkDoneUploading(chunk.id);
                        var endTimeChunkUpload = new Date().getTime();
                        var calculateNewAverageUploadSpeedResult = averageUploadSpeed(startTimeChunkUpload, endTimeChunkUpload, chunk.data.size);
                        (_b = (_a = uploader.events).onEstimatedSpeedUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, calculateNewAverageUploadSpeedResult);
                    })
                        .catch(function (error) {
                        if (axios_1.default.isCancel(error)) {
                            // TODO: Implement onCancel event
                        }
                        else {
                            state.fileUploads.incrementChunksDoneCount(chunk.fileId);
                            uploader.chunkDoneUploading(chunk.id);
                        }
                    })
                        .finally(function () {
                        // check if this chunk was final chunk of the file, if so finalise the upload
                        if (fileUpload.chunksDoneCount === fileUpload.chunksCount) {
                            (0, exports.finaliseUpload)(fileUpload, state);
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
};
exports.uploadChunk = uploadChunk;
/**
 * Finalise the upload. This is called by `worker.uploadChunk` when
 * the amount of uploaded chunks equals the total amount
 * of chunks for a file.
 */
var finaliseUpload = function (fileUpload, state) {
    var fileId = fileUpload.fileId, uploader = fileUpload.uploader;
    log.info("Finalising: ".concat(fileUpload.id));
    api
        .finalise(fileUpload)
        .then(function () {
        log.info("Finalised: ".concat(fileUpload.id));
        uploader.events.onCompleted(fileId, null, fileUpload.id);
        uploader.removeFileFromQueue(fileId);
    })
        .catch(function (error) {
        if (error.response &&
            error.response.status &&
            error.response.status === 409) {
            var missingChunkNumbers = error.response.data['missing_chunks'];
            for (var _i = 0, missingChunkNumbers_1 = missingChunkNumbers; _i < missingChunkNumbers_1.length; _i++) {
                var chunkNumber = missingChunkNumbers_1[_i];
                uploader.retryChunkForFile(fileUpload, chunkNumber);
            }
        }
        else {
            uploader.events.onError(fileId, error, fileUpload.id);
        }
    });
};
exports.finaliseUpload = finaliseUpload;
exports.default = exports.uploadChunk;
//# sourceMappingURL=worker.js.map